<template>
  <div 
    class="overlay-item" 
    :class="`overlay-item--${color}`" 
    :style="props.color === 'legend' ? { background: `url(${BG_LEGEND})` } : {}"
  >
    <div class="overlay-item__wrapper">
      <div class="overlay-item__icon-box">
        <component 
          :is="currentIcon" 
          class="overlay-item__icon" 
          :class="{
            'overlay-item__icon--pen' : props.icon === 'pen',
            'overlay-item__icon--alpha' : props.icon === 'alpha',
          }"
        />
      </div>
      <span class="overlay-item__txt">{{ text }}</span>
    </div>
    <CloseButton @click="close()" />
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';
  import { BG_LEGEND } from '@/Groups/OverlayManager/private/imports/sharedMedia';
  //------------------
  import CloseButton from '@/Groups/OverlayManager/private/ui/CloseButton/CloseButton.vue';
  //------------------
  import WifiIcon from '@/Groups/OverlayManager/private/svg/WifiIcon.vue';
  import SignalIcon from '@/Groups/OverlayManager/private/svg/SignalIcon.vue';
  import PersonIcon from '@/Groups/OverlayManager/private/svg/PersonIcon.vue';
  import PenIcon from '@/Groups/OverlayManager/private/svg/PenIcon.vue';
  import DeleteIcon from '@/Groups/OverlayManager/private/svg/DeleteIcon.vue';
  import CopyIcon from '@/Groups/OverlayManager/private/svg/CopyIcon.vue';
  import PinIcon from '@/Groups/OverlayManager/private/svg/PinIcon.vue';
  import AlphaIcon from '@/Groups/OverlayManager/private/svg/AlphaIcon.vue';
  import TelegramIcon from '@/Groups/OverlayManager/private/svg/TelegramIcon.vue';
  import LockIcon from '@/Groups/OverlayManager/private/svg/LockIcon.vue';
  import CrownIcon from '@/Groups/OverlayManager/private/svg/CrownIcon.vue';
  import CloudIcon from '@/Groups/OverlayManager/private/svg/CloudIcon';
  import StarIcon from '@/Groups/OverlayManager/private/svg/StarIcon.vue';
  import MessageIcon from '@/Groups/OverlayManager/private/svg/MessageIcon.vue';
  //------------------
  const store = useStore();
  const props = defineProps({
    id: { ype: Number, required: true },
    text: { type: String, required: true },
    color: { type: String, required: false, default: 'default' },
    icon: { type: String, required: false, default: null }
  });
  //------------------
  const iconMap = {
    wifi: WifiIcon,
    signal: SignalIcon,
    person: PersonIcon,
    pen: PenIcon,
    delete: DeleteIcon,
    copy: CopyIcon,
    pin: PinIcon,
    alpha: AlphaIcon,
    telegram: TelegramIcon,
    lock: LockIcon,
    crown: CrownIcon,
    star: StarIcon,
    message: MessageIcon,
    cloud: CloudIcon,
  };
  //------------------
  const currentIcon = computed(() => iconMap[props.icon] || iconMap.default);
  //------------------
  const close = () => {
    store.commit('OverlayManager/toRemoveItem', props.id);
  };
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>